import { ApolloLink } from 'apollo-link'
import authLink from './auth.link'
import httpLink from './http.link'
import retryLink from './retry.link'

export default ApolloLink.from([retryLink, authLink, httpLink])
